import { trpc } from '@/data-loaders';
import type { AccessType } from '#server/models';

export const useAreaConfig = (areaSlug?: string, requiredAccessType?: AccessType) => {
  return trpc.getAreaConfig.useQuery(
    { areaSlug: areaSlug ?? '', requiredAccessType },
    {
      retry: false,
      gcTime: 1000 * 60 * 60 * 8, // cache for 8 hours
      staleTime: 1000 * 60 * 60 * 8, // don't consider the data stale until 8 hours
      enabled: !!areaSlug
    }
  );
};
